<div class="phone-verification-modal">
  <div class="modal-header">
    <h2 class="modal-title">
      Phone Verification Required
    </h2>
  </div>

  <div class="modal-body">
    <!-- Message -->
    <p class="modal-message">
      {{ data?.message || 'Before accessing billing information, please verify your phone number. This helps us keep your account secure and provide better support.' }}
    </p>

    <!-- Info Box -->
    <div class="info-box">
      <mat-icon class="info-icon">info</mat-icon>
      <p class="info-text">You will receive a 6-digit verification code via SMS on your phone number.</p>
    </div>

    <!-- Error Display -->
    <div class="error-box" *ngIf="errorMessage">
      <mat-icon class="error-icon">error</mat-icon>
      <p class="error-text">{{ errorMessage }}</p>
    </div>

    <form [formGroup]="verificationForm">
      <!-- Step 1: Phone Number Entry -->
      <div *ngIf="step === 'phone'" class="step-phone">
        <!-- Country Code Selector -->
        <mat-form-field appearance="outline" class="country-code-field">
          <span matPrefix class="country-prefix">
            <span class="country-flag fi fi-{{ getSelectedCountry()?.code?.toLowerCase() }}"></span>
            <span class="country-code-label">{{ getSelectedCountry()?.code }}</span>
            <span class="country-dial">{{ selectedCountryCode }}</span>
          </span>
          <mat-select [(value)]="selectedCountryCode" (selectionChange)="onCountryChange($event)" class="country-select">
            <mat-option *ngFor="let country of countries" [value]="country.dialCode">
              <span class="country-option">
                <span class="flag fi fi-{{ country.code.toLowerCase() }}"></span>
                <span class="country-name">{{ country.name }}</span>
                <span class="dial-code">{{ country.dialCode }}</span>
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Phone Number Input -->
        <mat-form-field appearance="outline" class="phone-number-field">
          <input 
            matInput 
            type="tel" 
            formControlName="phoneNumber" 
            placeholder="Phone Number*"
            autocomplete="tel">
          <mat-icon matSuffix class="phone-icon">phone</mat-icon>
          <mat-error *ngIf="verificationForm.get('phoneNumber')?.hasError('required')">
            Phone number is required
          </mat-error>
          <mat-error *ngIf="verificationForm.get('phoneNumber')?.hasError('pattern')">
            Please enter a valid phone number
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Step 2: Code Verification -->
      <div *ngIf="step === 'code'" class="step-code">
        <div class="code-sent-info">
          <mat-icon class="info-icon">mark_email_read</mat-icon>
          <p class="info-text">
            We've sent a 6-digit code to <strong>{{ phoneNumber }}</strong> via SMS.
          </p>
        </div>

        <!-- Verification Code Input -->
        <mat-form-field appearance="outline" class="full-width code-input">
          <mat-label>Verification Code</mat-label>
          <mat-icon matPrefix>vpn_key</mat-icon>
          <input 
            matInput 
            type="text" 
            formControlName="code" 
            placeholder="123456"
            maxlength="6"
            autocomplete="one-time-code">
          <mat-hint>Enter the 6-digit code</mat-hint>
          <mat-error *ngIf="verificationForm.get('code')?.hasError('required')">
            Verification code is required
          </mat-error>
          <mat-error *ngIf="verificationForm.get('code')?.hasError('minlength') || verificationForm.get('code')?.hasError('maxlength')">
            Code must be 6 digits
          </mat-error>
        </mat-form-field>

        <!-- Resend Code -->
        <div class="resend-section">
          <button 
            type="button"
            mat-button 
            [disabled]="!canResend || isLoading"
            (click)="resendCode()"
            class="resend-btn">
            <mat-icon>refresh</mat-icon>
            <span *ngIf="!canResend && countdown > 0">Resend code in {{ countdown }}s</span>
            <span *ngIf="canResend">Resend Code</span>
          </button>
        </div>

        <!-- Change Phone Number -->
        <div class="change-phone">
          <button 
            type="button"
            mat-button 
            (click)="changePhoneNumber()"
            class="change-phone-btn">
            Change Phone Number
          </button>
        </div>
      </div>
    </form>

    <!-- Loading Indicator -->
    <div *ngIf="isLoading" class="loading-overlay">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  </div>

  <div class="modal-footer">
    <button 
      mat-stroked-button 
      type="button" 
      class="cancel-btn" 
      (click)="cancel()"
      [disabled]="isLoading">
      Skip, Still Explore
    </button>
    
    <button 
      *ngIf="step === 'phone'"
      mat-flat-button 
      type="button" 
      class="send-btn" 
      (click)="sendCode()"
      [disabled]="verificationForm.get('phoneNumber')?.invalid || isLoading">
      Send Code
    </button>
    
    <button 
      *ngIf="step === 'code'"
      mat-flat-button 
      type="button" 
      class="verify-btn" 
      (click)="verifyCode()"
      [disabled]="verificationForm.get('code')?.invalid || isLoading">
      Verify Code
    </button>
  </div>
</div>

